export const RemoveIcon = () => {
  return <span className="material-symbols-outlined">remove</span>;
};
